enum CurrencyCodeEnum {
    CZK = "CZK",
    EUR = "EUR"
}

export default CurrencyCodeEnum;
